import React from 'react';
import styles from './index.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { currentUrl } from 'utils/url-helper';

const PageNotFound = () => {
  const { t } = useTranslation();
  let description = t('page_not_found.description').split('\n');
  return (
    <div className={styles['page-not-found']}>
      <div className={styles.title}>{t('page_not_found.title')}</div>
      <div className={styles.description}>
        {description.map(x => (
          <>
            {x}
            <br />
          </>
        ))}
      </div>
      <Link to={currentUrl('/')}>
        <div className={styles.back}>{t('page_not_found.back')}</div>
      </Link>
    </div>
  );
};

export default PageNotFound;
